module.exports = __webpack_public_path__ + "media/images/icon_review-49033fd8a5e5c846d7c72c97d0b675dc.png";